import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-white via-blue-50/30 to-primary/5 py-20 lg:py-32 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-primary/20"></div>
        <div className="absolute bottom-20 right-10 w-24 h-24 rounded-full bg-secondary/20"></div>
        <div className="absolute top-1/2 left-1/3 w-16 h-16 rounded-full bg-accent/20"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
              <Icon name="Sparkles" size={16} />
              <span>Leading AI Consultancy Since 2020</span>
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">
              Transform Your Business with 
              <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent"> AI Excellence</span>
            </h1>
            
            <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto lg:mx-0">
              RCEG AI Ventures delivers cutting-edge artificial intelligence solutions, software development, and cybersecurity services that drive measurable business growth for enterprise clients worldwide.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
                variant="default" 
                size="lg"
                iconName="ArrowRight"
                iconPosition="right"
                onClick={() => window.location.href = '/contact-consultation-request'}
                className="text-lg px-8 py-4"
              >
                Get Started
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                iconName="Play"
                iconPosition="left"
                onClick={() => window.location.href = '/services-overview'}
                className="text-lg px-8 py-4"
              >
                View Case Studies
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 mt-12 pt-8 border-t border-border">
              <div className="text-center lg:text-left">
                <div className="text-3xl font-bold text-primary mb-1">500+</div>
                <div className="text-sm text-muted-foreground">Projects Delivered</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl font-bold text-primary mb-1">98%</div>
                <div className="text-sm text-muted-foreground">Client Satisfaction</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl font-bold text-primary mb-1">50+</div>
                <div className="text-sm text-muted-foreground">Enterprise Clients</div>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative bg-white rounded-2xl shadow-elevation p-8 border border-border">
              {/* AI Dashboard Mockup */}
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 rounded-full gradient-primary flex items-center justify-center">
                      <Icon name="Brain" size={16} color="white" />
                    </div>
                    <div>
                      <div className="font-semibold text-foreground">AI Analytics Dashboard</div>
                      <div className="text-sm text-muted-foreground">Real-time insights</div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-1 text-success">
                    <Icon name="TrendingUp" size={16} />
                    <span className="text-sm font-medium">+24.5%</span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-primary/5 rounded-lg p-4">
                    <div className="text-2xl font-bold text-primary mb-1">94.2%</div>
                    <div className="text-sm text-muted-foreground">Model Accuracy</div>
                  </div>
                  <div className="bg-success/5 rounded-lg p-4">
                    <div className="text-2xl font-bold text-success mb-1">2.3s</div>
                    <div className="text-sm text-muted-foreground">Response Time</div>
                  </div>
                </div>

                <div className="space-y-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-muted-foreground">Processing Status</span>
                    <span className="text-foreground font-medium">87%</span>
                  </div>
                  <div className="w-full bg-muted rounded-full h-2">
                    <div className="bg-gradient-to-r from-primary to-secondary h-2 rounded-full" style={{ width: '87%' }}></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-16 h-16 bg-accent rounded-full flex items-center justify-center shadow-soft">
              <Icon name="Zap" size={24} color="white" />
            </div>
            <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-warning rounded-full flex items-center justify-center shadow-soft">
              <Icon name="Shield" size={16} color="white" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;